import React, { createContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import actionCable from 'actioncable'
import { getAccessToken } from 'src/services/common/storage'

const CableApp = {}
const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_SERVER_URL || ''

export const ActionCableContext = createContext()

const ActionCableProvider = ({ children }) => {
  const [token, setToken] = useState(getAccessToken() || '')

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(getAccessToken() || '')
    }

    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('auth:logout', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('auth:logout', handleStorageChange)
    }
  }, [])

  if (token) {
    CableApp.cable = actionCable.createConsumer(`${SOCKET_SERVER_URL}?token=${token.replace(/"/g, '')}`)
    return <ActionCableContext.Provider value={CableApp.cable}>{children}</ActionCableContext.Provider>
  }

  return <div>{children}</div>
}

ActionCableProvider.propTypes = {
  children: PropTypes.object
}

export default ActionCableProvider
